export const FB_GROUP_HOC10 =
  "https://www.facebook.com/groups/hoc10donghanhcunggiaovientieuhoc";

export const COLOR_PRIMARY = "#ff7707";
